var _metadata, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTalkproLogoGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "37.000000pt",
    height: "27.000000pt",
    viewBox: "0 0 37.000000 27.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,27.000000) scale(0.100000,-0.100000)",
    fill: "#28c345",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267 214 l-88 -56 -83 51 c-46 28 -86 51 -90 51 -3 0 -6 -54 -6 -120 0 -71 4 -120 10 -120 5 0 45 23 89 51 l81 51 88 -56 c48 -31 91 -56 95 -56 4 0 7 58 7 130 0 72 -3 130 -7 130 -5 0 -48 -25 -96 -56z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkproLogoGreen);
export default __webpack_public_path__ + "static/media/talkpro_logo_green.9b12f9b472a29fdf6dd9904d00e98fe8.svg";
export { ForwardRef as ReactComponent };